import { Selector } from '../StoreConfig';
import { ResponsibleSalesList } from './types';

export const selectResponsibleSales: Selector<ResponsibleSalesList> =  (state) => {
  return state.responsibleSales;
};
